export default {
  data() {
    return {
      line: '',
      lineBreakdown: []
    }
  },
  computed: {
    businessLineOptions() {
      const catalog = Array.isArray(this.$store.getters.getLines) ? this.$store.getters.getLines : []
      const options = [
        { id: '', name: 'Todas las líneas' },
        ...catalog.map(l => ({ id: String(l.id), name: l.name }))
      ]
      if (this.lineBreakdown.some(l => l.id === 'none')) options.push({ id: 'none', name: 'Sin línea' })
      return options
    },
    selectedLineName() {
      const option = this.businessLineOptions.find(o => String(o.id) === String(this.line))
      return option ? option.name : 'Todas las líneas'
    }
  },
  methods: {
    toggleLine(id) {
      this.line = String(this.line) === String(id) ? '' : String(id)
    },
    lineQuery() {
      return this.line ? '&line=' + encodeURIComponent(this.line) : ''
    },
    setLineBreakdown(rows) {
      this.lineBreakdown = (rows || []).map(l => ({ ...l, id: String(l.id) }))
    }
  },
  created() {
    const lines = this.$store.getters.getLines
    if (!Array.isArray(lines) || !lines.length) this.$store.dispatch('getLines')
  }
}
